// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__2S-S7","importantInfo":"styles_importantInfo__2MbWc"};